import {Button, Icon, FontAwesomeIcon} from "~/components";
import {useCan} from "~/hooks";
import {Popconfirm} from "antd";

function EvaluationAction({item, onReEvaluate, locked, unlocked, onSetCycle}) {

	const can = {
		reEvaluate: useCan('evaluationReEvaluate'),
		setCycle: useCan('evaluationSetCycle'),
		lock: useCan('personnelBlock'),
	};

	const userLocked = item.user?.locked === 1;

	return (
		<div className="table-action d-flex">
			{can.reEvaluate && <Popconfirm title="Đánh giá lại" description="Tính lại doanh thu và cập nhật kết quả cho kỳ này?" onConfirm={() => onReEvaluate(item)}>
				<Button background blue noneBorder leftIcon={Icon.reload}></Button>
			</Popconfirm>}
			{can.setCycle && <Button background white leftIcon={Icon.calendar} onClick={() => onSetCycle(item)}></Button>}
			{(can.lock && !userLocked) && <Popconfirm title="Khóa nhân viên" description="Bạn có chắc chắn muốn khóa nhân viên này?" onConfirm={() => locked(item)}>
				<Button background yellow noneBorder leftIcon={<FontAwesomeIcon icon="fa-regular fa-user-lock" />}></Button>
			</Popconfirm>}
			{(can.lock && userLocked) && <Popconfirm title="Mở khóa nhân viên" description="Bạn có chắc chắn muốn mở khóa nhân viên này?" onConfirm={() => unlocked(item)}>
				<Button background green noneBorder leftIcon={<FontAwesomeIcon icon="fa-regular fa-user-unlock" />}></Button>
			</Popconfirm>}
		</div>
	);
}

export default EvaluationAction;
